<template>
  <Section>
    <SectionHeader :title="$t('apps.billing.message.summarybyservice')"/>
    <FormRow>
      <Col className="col-lg-12">
      <BaseTable
        class="custom-table"
        tableClass="table-bordered"
        hidePagination
      >
        <template #thead>
          <thead>
            <tr>
              <th style="width: 125px;">{{ $t('apps.billing.label.item') }}</th>
              <th>{{ $t('apps.billing.label.detail') }}</th>
              <th class="text-center">{{ $t('apps.billing.label.usedfree') }}</th>
              <th class="text-center">{{ $t('apps.billing.label.usedall') }}</th>
              <th class="text-center">{{ $t('apps.billing.label.usedwithcharge') }}</th>
              <th
                style="width: 140px;"
                class="text-right">{{ $t('apps.billing.label.payamount') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <!-- Application -->
            <tr
              v-for="(item, index) in apps"
              :key="index"
            >
              <td>
                {{ item.app.title }}
              </td>
              <td style="border-right: 1px solid #dee2e6;">
                {{ item.module.title }}
              </td>
              <td class="text-center">
                {{ item.freeUsedTotal }}
              </td>
              <td class="text-center">
                {{ item.usedTotal }}
              </td>
              <td class="text-center">
                {{ item.chargeUsedTotal }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(item.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Branch -->
            <tr>
              <td>
                {{ $t('apps.billing.message.branch') }}
              </td>
              <td>
                {{ $t('apps.billing.message.branchcount') }}
              </td>
              <td class="text-center">
                {{ numberel(data.branch.freeTotal) }}
              </td>
              <td class="text-center">
                {{ numberel(data.branch.countAllTotal) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.branches', { number: numberel(data.branch.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.branch.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Warehouse -->
            <tr>
              <td>
                {{ $t('apps.billing.message.warehouse') }}
              </td>
              <td>
                {{ $t('apps.billing.message.warehousecount') }}
              </td>
              <td class="text-center">
                {{ numberel(data.warehouse.freeTotal) }}
              </td>
              <td class="text-center">
                {{ numberel(data.warehouse.countAllTotal) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.warehouses', { number: numberel(data.warehouse.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.warehouse.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- User -->
            <tr>
              <td>
                {{ $t('apps.billing.message.user') }}
              </td>
              <td>
                {{ $t('apps.billing.message.usercount') }}
              </td>
              <td class="text-center">
                {{ numberel(data.user.freeTotal) }}
              </td>
              <td class="text-center">
                {{ numberel(data.user.countAllTotal) }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.users', { number: numberel(data.user.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.user.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <!-- Storeage -->
            <tr>
              <td rowspan="2">
                {{ $t('apps.billing.message.storage') }}
              </td>
              <td>
                {{ $t('apps.billing.message.application') }}
              </td>
              <td class="text-center">
                {{ numberel(data.record.freeTotal) }}
              </td>
              <td
                class="text-center"
                style="position: relative;">
                <span
                  class="link"
                  @click="onOpenUsageModal(UsageInfoType.Record)">
                  {{ numberel(data.record.countAllTotal) }}
                </span>
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.records', { number: numberel(data.record.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.record.amountTotal, '0,0.00[00000000]')) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('apps.billing.message.file') }}
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.files', { number: numberel(data.file.freeTotal, '0,0.00') }) }}
              </td>
              <td class="text-center">
                <span
                  class="link"
                  @click="onOpenUsageModal(UsageInfoType.File)">
                  {{ $t('apps.billing.message.files', { number: numberel(data.file.countAllTotal, '0,0.00') }) }}
                </span>
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.files', { number: numberel(data.file.countChargeTotal, '0,0.00') }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.file.amountTotal, '0,0.00[00000000]')) }}
              </td>
            </tr>
            <!-- Add on -->
            <tr>
              <td rowspan="3">
                {{ $t('apps.billing.message.addon') }}
              </td>
              <td>
                {{ $t('apps.billing.message.linemessage') }}
              </td>
              <td class="text-center">
                {{ numberel(data.messageLine.freeTotal) }}
              </td>
              <td class="text-center">
                <span
                  class="link"
                  @click="onOpenUsageModal(UsageInfoType.MessageLine)">
                  {{ numberel(data.messageLine.countAllTotal) }}
                </span>
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.linemessages', { number: numberel(data.messageLine.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.messageLine.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('apps.billing.message.email') }}
              </td>
              <td class="text-center">
                {{ numberel(data.email.freeTotal) }}
              </td>
              <td class="text-center">
                <span
                  class="link"
                  @click="onOpenUsageModal(UsageInfoType.Email)">
                  {{ numberel(data.email.countAllTotal) }}
                </span>
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.emails', { number: numberel(data.email.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.email.amountTotal, '0,0.00')) }}
              </td>
            </tr>
            <tr>
              <td>
                {{ $t('apps.billing.message.qrcode') }}
              </td>
              <td class="text-center">
                {{ numberel(data.qrcode.freeTotal) }}
              </td>
              <td class="text-center">
                <span
                  class="link"
                  @click="onOpenUsageModal(UsageInfoType.QRCode)">
                  {{ numberel(data.qrcode.countAllTotal) }}
                </span>
              </td>
              <td class="text-center">
                {{ $t('apps.billing.message.qrcodes', { number: numberel(data.qrcode.countChargeTotal) }) }}
              </td>
              <td class="text-right">
                {{ getCurrencyWithNumber(numberel(data.qrcode.amountTotal, '0,0.00')) }}
              </td>
            </tr>
          </tbody>
        </template>
      </BaseTable>
      </Col>
      <Col className="col-lg-12">
      <div class="summary-container">
        <div class="text">
          <strong>
            {{ $t('apps.billing.message.total') }}
          </strong>
        </div>
        <div class="value">
          {{ getCurrencyWithNumber(numberel(data.total, '0,0.00[0000]')) }}
        </div>
      </div>
      </Col>
    </FormRow>
  </Section>
</template>

<script>
import { UsageInfoType } from '../apps/billing/serviceused/Index.vue'

export default {
  props: {
    data: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    apps: {
      required: true,
      type: Array,
      default: () => ([]),
    },
  },

  data () {
    return {
      UsageInfoType,
    }
  },

  methods: {
    onOpenUsageModal (type) {
      this.$emit('onOpenUsageModal', type)
    },
    getRangeMinMax (min, max, total, { format }) {
      if (min === max) {
        return this.numberel(total, format)
      }
      return `${this.numberel(min, format)} - ${this.numberel(max, format)}`
    },
  },
}
</script>

<style scoped>
.custom-table /deep/ .table tr:hover {
  background: none;
}

.summary-container {
  display: flex;
  margin-top: 15px;
}

.summary-container .text {
  flex: 1;
  text-align: right;
}

.summary-container .value {
  width: 180px;
  padding-right: 11px;
  text-align: right;
}

.link {
  text-decoration: underline;
}

.link:hover {
  color: var(--link-color);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/ServiceUsedSummary.vue